import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/autoplay';
if (customElements.get('component-offers') === undefined) {
    class Offers extends HTMLElement {
        constructor() {
            super();
            this.carousel = null;
            this.next = this.querySelector('.swiper-button-next');
            this.prev = this.querySelector('.swiper-button-prev');
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.setCarousel();
            this.openMenu();
            this.accordeon();
        }
        setCarousel() {
            const carouselElement = document.querySelector("#offersCarousel .swiper-wrapper");
            if (carouselElement.children.length === 1) {
                // Duplicamos el elemento si solo hay uno
                let clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
                clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
                clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
                clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
                clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
                clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
                clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
                clone = carouselElement.children[0].cloneNode(true);
                carouselElement.appendChild(clone);
            }
            new Swiper("#offersCarousel", {
                spaceBetween: 95,
                freeMode: true,
                grabCursor: true,
                slidesPerView: 'auto',
                loop: true,
                loopAdditionalSlides: 20,
                loopAddBlankSlides: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                    reverseDirection: true,
                },
                speed: 15000,
                freeModeMomentum: false,
                modules: [Autoplay],
            });
        }
        openMenu() {
            const offcanvas = document.getElementById('menuMovil');
            const back = document.querySelector('.header-offcanvas-backdrop');
            document.querySelector('.open-btn').addEventListener('click', () => {
                offcanvas.classList.toggle('show');
                back.classList.toggle('show');
            });
            document.querySelector('.close-btn').addEventListener('click', () => {
                offcanvas.classList.toggle('show');
                back.classList.toggle('show');
            });
            back.addEventListener('click', () => {
                offcanvas.classList.toggle('show');
                back.classList.toggle('show');
            });
        }
        accordeon() {
            //console.log(document.querySelectorAll('.accordion-button'))
            document.querySelectorAll('.accordion-button').forEach(button => {
                button.addEventListener('click', function () {
                    const collapse = this.parentElement.nextElementSibling;
                    collapse.classList.toggle('show');
                    this.classList.toggle('collapsed');
                });
            });
        }
    }
    customElements.define('component-offers', Offers);
}
if (customElements.get('component-membership') === undefined) {
    class Membership extends HTMLElement {
        constructor() {
            super();
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.check();
        }
        check() {
            const userId = this.getAttribute('data-user');
            const membershipId = this.getAttribute('data-membership');
            // Obtener la fecha de hoy en formato YYYY-MM-DD
            const today = new Date().toISOString().split('T')[0];
            // Revisar si ya se verificó la membresía hoy
            const lastCheckedDate = localStorage.getItem('membership-check-date');
            if (lastCheckedDate === today) {
                console.log('La membresía ya se verificó hoy.');
                return;
            }
            // Realizar la solicitud a la API
            fetch(`https://controlexpert.goldensubdev.com/check.php?user=${userId}&id=${membershipId}`)
                .then(response => response.json())
                .then(data => {
                if (data.status === 'ok') {
                    console.log('La membresía ha sido verificada.', data.message);
                }
                else {
                    console.error('Error al verificar la membresía:', data.message);
                }
                // Actualizar localStorage para indicar que la verificación se realizó hoy
                localStorage.setItem('membership-check-date', today);
            })
                .catch(error => {
                console.error('Error en la solicitud de verificación de membresía:', error);
            });
        }
    }
    customElements.define('component-membership', Membership);
}
